import { Badge, Box, Stack, Toolbar, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Iconify from "src/components/Iconify";
import Logo from "src/components/Logo";
import { IconButtonAnimate } from "src/components/animate";
import Settings from "src/components/settings";
import { HEADER } from "src/config";
import useAuth from "src/hooks/useAuth";
import useOffSetTop from "src/hooks/useOffSetTop";
import useResponsive from "src/hooks/useResponsive";
import { RootStyle } from "src/layouts/shared";
import { PATH_DASHBOARD, PATH_USER } from "src/routes/paths";
import AccountPopover from "./AccountPopover";
import LanguagePopover from "./LanguagePopover";
import NotificationsPopover from "./NotificationsPopover";
import QuickPopover from "./QuickPopover";

DashboardHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
};

export const useStyles = makeStyles(() =>
  createStyles({
    rotateIcon: {
      animation: "$spin 8s linear infinite",
    },
    "@keyframes spin": {
      "0%": {
        transform: "rotate(360deg)",
      },
      "100%": {
        transform: "rotate(0deg)",
      },
    },
  })
);

export default function DashboardHeader({
  onOpenSidebar,
  isCollapse = false,
  verticalLayout = false,
}) {
  const navigate = useNavigate();
  const isOffset =
    useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const isDesktop = useResponsive("up", "lg");

  const [openSettings, setOpenSettings] = useState(false);

  const handleOpenSettings = () => {
    setOpenSettings((prev) => !prev);
  };

  const handleCloseSettings = () => {
    setOpenSettings(false);
  };
  const { isAdmin } = useAuth();
  const classes = useStyles();

  const handleCartRedirection = () => {
    navigate(PATH_USER.onlineStore.productSubscription.checkout);
  };

  return (
    <>
      <RootStyle
        isCollapse={isCollapse}
        isOffset={isOffset}
        verticalLayout={verticalLayout}
      >
        <Toolbar
          sx={{
            backgroundColor: "background.paper",
            minHeight: "100% !important",
            px: { lg: 5 },
          }}
        >
          {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}

          {!isDesktop && (
            <>
              <IconButtonAnimate
                onClick={onOpenSidebar}
                sx={{ mr: 1, color: "text.primary" }}
              >
                <Iconify icon="eva:menu-2-fill" />
              </IconButtonAnimate>
            </>
          )}
          {isAdmin ? (
            <>
              {isDesktop && (
                <>
                  <Tooltip title="products">
                    <IconButtonAnimate
                      LinkComponent={Link}
                      to={PATH_DASHBOARD.store.products}
                      sx={{ mr: 1, color: "text.disabled" }}
                    >
                      <Iconify icon="material-symbols:shopping-cart-outline" />
                    </IconButtonAnimate>
                  </Tooltip>

                  <Tooltip title="materials">
                    <IconButtonAnimate
                      LinkComponent={Link}
                      to={PATH_DASHBOARD.store.material}
                      sx={{ mr: 1, color: "text.disabled" }}
                    >
                      <Iconify icon="material-symbols:folder-outline" />
                    </IconButtonAnimate>
                  </Tooltip>
                  <Tooltip title="help center">
                    <IconButtonAnimate
                      LinkComponent={Link}
                      to={PATH_DASHBOARD.communication.help_center}
                      sx={{ mr: 1, color: "text.disabled" }}
                    >
                      <Iconify icon="bx:support" />
                    </IconButtonAnimate>
                  </Tooltip>
                  <Tooltip title="network settings">
                    <IconButtonAnimate
                      LinkComponent={Link}
                      to={PATH_DASHBOARD.settings.network.root}
                      sx={{ mr: 1, color: "text.disabled" }}
                    >
                      <Iconify icon="material-symbols:settings" />
                    </IconButtonAnimate>
                  </Tooltip>
                </>
              )}
            </>
          ) : null}

          <Box sx={{ flexGrow: 1 }} />

          <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 0.5, sm: 1.5 }}
          >
            {/* {!isDesktop && <QuickPopover />} */}

            {!isAdmin && (
              <IconButtonAnimate onClick={handleCartRedirection}>
                <Iconify icon="mdi:cart" />
              </IconButtonAnimate>
            )}

            <NotificationsPopover />
            <Badge
              color="error"
              variant="dot"
              sx={{
                "& .MuiBadge-badge": {
                  top: "7px",
                  right: "7px",
                },
              }}
            >
              <IconButtonAnimate
                onClick={() => handleOpenSettings()}
                className={classes.rotateIcon}
              >
                <Iconify icon="solar:settings-bold-duotone" />
              </IconButtonAnimate>
            </Badge>
            <LanguagePopover />
            <AccountPopover />
          </Stack>
        </Toolbar>
      </RootStyle>

      <Settings handleClose={handleCloseSettings} open={openSettings} />
    </>
  );
}
